module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAALCAQAAAAOu8/qAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAAAMgAAADIAGP6560AAAAHdElNRQfkBBQDFifQLivZAAAAEGNhTnYAAAAgAAAAIAAAAAIAAAAFaBNJFQAAADRJREFUGNNjYACB/0CISkLBfxBAJWHS/9EBA0QauyRM6j8uqf/YAU4pgjZhkUT2GZokQSkA3lXCPptswKcAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjAtMDQtMjBUMDM6MjI6MzgrMDA6MDBt+7dhAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTA0LTIwVDAzOjIyOjM4KzAwOjAwHKYP3QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/icons/closedhand.png
// module id = TdUF
// module chunks = 18